import { Button } from '@pickatale/ui-kit';

interface TextPasswordInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  onSubmit: () => void;
}

export const TextPasswordInput = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  onSubmit,
}: TextPasswordInputProps) => (
  <div className="flex flex-col gap-3 w-72 mx-auto">
    <input
      type="password"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full text-neutral-700 placeholder:text-neutral-400 disabled:opacity-50 disabled:cursor-not-allowed border border-neutral-300 rounded-md p-3"
      disabled={disabled}
    />
    <Button
      className="bg-pt-primary text-white hover:bg-pt-primary-accent hover:text-black"
      variant="filled"
      onClick={() => {
        console.log('test');
        onSubmit();
      }}
    >
      Login!
    </Button>
  </div>
);
